import { redirectToLead } from '../lead.popup/redirectToLead';
import { unitApi } from '../services/api';

(function () {
  'use strict';

  angular
    .module('unit.deal.lead')
    .controller('unitDealLeadCtrl', unitDealLeadCtrl);

  unitDealLeadCtrl.$inject = [
    'UnitDealLead',
    '$rootScope',
    '$scope',
    '$location',
    '$anchorScroll',
    '$window',
    '$state',
    '$cookieStore',
    '$timeout',
    '$mdToast',
    '$mdDialog',
    'moment',
    'UnitCancelDealService',
    'estContactsChecker',
    '$translate',
    'telFilter',
    'localStorageService',
  ];

  function unitDealLeadCtrl(
    UnitDealLead,
    $rootScope,
    $scope,
    $location,
    $anchorScroll,
    $window,
    $state,
    $cookieStore,
    $timeout,
    /** @type {angular.material.IToastService} */ $mdToast,
    /** @type {angular.material.IDialogService} */ $mdDialog,
    moment,
    UnitCancelDealService,
    estContactsChecker,
    $translate,
    telFilter,
    localStorageService,
  ) {
    var vm = this,
      assign = (vm.model.lead_unit_assn = vm.model.lead_unit_assn || {}),
      unit = vm.model,
      editDealPaymentState,
      editDealPriceState,
      editDealTotalState;
    vm.lead = {};

    vm.autoCancelTimer = null;
    vm.unitDealEditor = true;
    vm.unitReservationEditor = true;
    vm.leadExists = false;

    var textReservationCanceled = $translate.instant(
      'unit.popup.unitdeallead.reservation.cancel.canceled',
    );
    var textUndo = $translate.instant('general.undo');
    var textNoName = $translate.instant('unit.popup.noname');

    var textModalTitle = $translate.instant(
      'unit.popup.unitdeallead.deal.modal.title',
    );
    var textModalMessage = $translate.instant(
      'unit.popup.unitdeallead.deal.modal.message',
    );
    var textGotIt = $translate.instant('general.modal.got.it');

    $rootScope.$on('$translateChangeSuccess', function () {
      textReservationCanceled = $translate.instant(
        'unit.popup.unitdeallead.reservation.cancel.canceled',
      );
      textUndo = $translate.instant('general.undo');
      textNoName = $translate.instant('unit.popup.noname');

      textModalTitle = $translate.instant(
        'unit.popup.unitdeallead.deal.modal.title',
      );
      textModalMessage = $translate.instant(
        'unit.popup.unitdeallead.deal.modal.message',
      );
      textGotIt = $translate.instant('general.modal.got.it');
    });

    vm.customFields = UnitDealLead.getCustomFields({}, function (resp) {
      // also create proper array of customFields
      if (assign.deal && assign.deal.custom_fields) {
        var customFieldsArr = [];
        angular.forEach(assign.deal.custom_fields, function (value, key) {
          angular.forEach(vm.customFields, function (val, k) {
            if (key === val.id) {
              customFieldsArr.push({ name: val.name, value: value });
            }
          });
        });
        assign.deal.customFieldsArr = customFieldsArr;
      }
    });

    function changeViewState() {
      // WARNING
      $rootScope.$broadcast('lock.unit.deal.lead', false);
      if (!unit.status) {
        vm.state = null;
      } else if (unit.status.type == '3') {
        if (assign.lead && assign.lead.id) {
          vm.state = 'reserved';
          $timeout.cancel(vm.autoCancelTimer);
          $rootScope.$broadcast('lock.unit.status.by.type', 'reserved');
        } else {
          vm.lead = {};
          vm.state = 'reserved-add-lead';
          if (!vm.model.status_lock) {
            vm.autoCancelTimer = $timeout(function () {
              vm.autoCancelAdd();
            }, 120000);
          }

          $rootScope.$broadcast('lock.unit.deal.lead', true);
        }
      } else if (unit.status.type == '4') {
        // заполненное значение assign._price_default_filled будет у менеджера заполнящего сделку, а у параллельно смотрящего будет assign.deal.price == '0'
        // поэтому проверяем, что ни одно из этих условий не выполняется
        if (
          assign.lead &&
          assign.lead.id &&
          assign.deal &&
          assign.deal.price &&
          !(assign._price_default_filled || assign.deal.price == '0')
        ) {
          vm.state = 'sold';
          $timeout.cancel(vm.autoCancelTimer);
          $rootScope.$broadcast('lock.unit.status.by.type', 'sold');
        } else if (assign.lead && assign.lead.id) {
          if (assign.updated_by != $rootScope.user_id) {
            vm.unitDealEditor = false;
          }
          assign.deal = assign.deal || {};
          assign._price_default_filled = true;
          assign.deal.price = vm.model.price;
          assign.deal.extra = vm.model.extra || 0;
          assign.deal.deal_total =
            Math.round(1 * vm.model.price * vm.model.area_total) || 0;
          assign.deal.payment_type = assign.deal.payment_type || '1';
          assign.deal.freq_payment = assign.deal.freq_payment || '1';
          assign.deal.discount = assign.deal.discount || '0';
          assign.deal.punishment = assign.deal.punishment || '1';

          $timeout.cancel(vm.autoCancelTimer);

          vm.state = 'sold-add-deal-info';

          $rootScope.$broadcast('lock.unit.deal.lead', true);
        } else {
          vm.lead = {};
          vm.state = 'sold-add-lead';
          if (!vm.model.status_lock) {
            vm.autoCancelTimer = $timeout(function () {
              vm.autoCancelAdd();
            }, 120000);
          }
          $rootScope.$broadcast('lock.unit.deal.lead', true);
        }
      } else {
        vm.state = null;
      }
    }

    $scope.$on('unit.status.changed', function (e, arg) {
      if (arg.new_status.type == '2') {
        assign = vm.model.lead_unit_assn = {};
        $timeout.cancel(vm.autoCancelTimer);
        $rootScope.$broadcast('lock.unit.deal.lead', false);
      } else if (arg.new_status.type == '4' && arg.old_status.type != '4') {
        assign.deal = {};
        assign.updated_by = $rootScope.user_id;
      } else {
      }
      changeViewState();
    });

    $scope.$on('unit.editing.show', function (event, data) {
      if (vm.model.lead_unit_assn.type == 2) {
        vm.unitDealEditor = false;
        vm.unitReservationEditor = false;
      } else if (vm.model.lead_unit_assn.type == 1) {
        vm.unitReservationEditor = false;
      }
    });

    $scope.$on('unit.editing.hide', function (event, data) {
      vm.unitDealEditor = true;
      vm.unitReservationEditor = true;
    });

    $scope.$on('cancel.booking', function (e, arg) {
      vm.cancelReservation(vm.model.lead_unit_assn.id);
    });

    changeViewState();

    vm.saveNewLead = function (lead) {
      lead.action_type = unit.status.type == '3' ? 1 : 2;
      lead.unit_id = vm.unitId;
      lead.lead_id = lead.id;

      UnitDealLead.create(lead, function (response) {
        assign.created_at = response.lua.created_at;
        assign.created_by = response.lua.created_by;
        assign.due_date = response.lua.due_date;
        assign.lead = response;
        assign.id = response.lua_id;
        assign.manager = response.manager;

        changeViewState();
      });

      $timeout.cancel(vm.autoCancelTimer);
    };

    vm.cancelReservedAddLead = function () {
      vm.state = null;

      $rootScope.$broadcast('cancel.unit.reserved');
    };

    vm.autoCancelAdd = function () {
      if (Object.keys(vm.model.lead_unit_assn).length == 0) {
        $rootScope.$broadcast('cancel.unit.reserved');
        vm.state = null;
      }
      $timeout.cancel(vm.autoCancelTimer);
    };

    vm.cancelSoldAddLead = function () {
      vm.state = 'reserved';
      $rootScope.$broadcast('cancel.unit.sold');
    };

    // Edit lead

    vm.editLead = function (lead) {
      vm.lead = angular.copy(lead);

      // Хак, чтобы не терялись кастом филды, когда открываем редактирование сразу после создания
      // Почему-то в этот момент они не в виде объекта, а в виде массива объектов. Преобразовываем
      if (Array.isArray(vm.lead.custom_fields)) {
        var proxyCustomFieldsObj = {};
        angular.forEach(vm.lead.custom_fields, function (el, i) {
          proxyCustomFieldsObj[el.field_id] = el.value;
        });
        vm.lead.custom_fields = proxyCustomFieldsObj;
      }

      vm.state = 'edit-lead';
    };

    vm.saveEditLead = function (lead) {
      UnitDealLead.update({ id: lead.id }, lead, function (response) {
        assign.lead = response.result;

        changeViewState();
      });
    };

    vm.cancelEditLead = function () {
      changeViewState();
    };

    // Deal info

    vm.editDeal = function () {
      vm.state = 'sold-edit-deal-info';
      editDealPaymentState = assign.deal.payment_type;
      editDealPriceState = assign.deal.price;
      editDealTotalState = assign.deal.deal_total;
      //TODO convert datetime to date in DB or backend
      if (assign.deal.payments_end) {
        assign.deal.payments_end = assign.deal.payments_end.split(' ')[0];
      }
      if (assign.deal.payments_start) {
        assign.deal.payments_start = assign.deal.payments_start.split(' ')[0];
      }
      if (assign.deal.first_payment_date) {
        assign.deal.first_payment_date =
          assign.deal.first_payment_date.split(' ')[0];
      }

      // Hack to add another value to the view
      var extraCalculated =
        parseFloat(vm.model.lead_unit_assn.deal.deal_total) -
        1 *
          parseFloat(vm.model.lead_unit_assn.deal.price) *
          vm.model.area_total;
      if (extraCalculated > 1) {
        vm.model.lead_unit_assn.deal.extra = Math.round(extraCalculated);
      } else if (extraCalculated < 0) {
        vm.model.lead_unit_assn.deal.extra = 0;
        vm.model.lead_unit_assn.deal.deal_total =
          1 *
          parseFloat(vm.model.lead_unit_assn.deal.price) *
          vm.model.area_total;
        $mdDialog.show(
          $mdDialog
            .alert()
            .clickOutsideToClose(true)
            .title(textModalTitle)
            .textContent(textModalMessage)
            .ariaLabel('Alert Dialog')
            .ok(textGotIt),
        );
      } else {
        vm.model.lead_unit_assn.deal.extra = 0;
      }
    };

    vm.saveDeal = function (deal) {
      UnitDealLead.updateDeal(
        { id: vm.model.lead_unit_assn.id },
        deal,
        function (response) {
          assign._price_default_filled = false;
          assign.deal_id = response.result.deal_id;
          changeViewState();
          $rootScope.$broadcast('unit.reload');
          //$rootScope.$broadcast('activity.update');
        },
      );
    };

    vm.cancelNewDeal = function () {
      $rootScope.$broadcast('cancel.unit.sold');

      unitApi.getById(vm.unitId).then((response) => {
        vm.model.lead_unit_assn = response.lead_unit_assn;
      });

      changeViewState();
    };

    vm.cancelEditDeal = function () {
      changeViewState();
      if (editDealPaymentState) {
        assign.deal.payment_type = editDealPaymentState;
      }
      if (editDealPriceState) {
        assign.deal.price = editDealPriceState;
      }
      if (editDealTotalState) {
        assign.deal.deal_total = editDealTotalState;
      }
    };

    vm.cancelReservation = function (luaId) {
      // removed timer because of bugs (other unit statuses were changed)
      vm.state = null;
      UnitDealLead.cancelDeal({ id: luaId }, {}, function () {
        vm.model.lead_unit_assn = {};
        $rootScope.$broadcast('cancel.unit.reserved');
        changeViewState();
      });

      var toast = $mdToast
        .simple()
        .textContent(textReservationCanceled)
        .position('bottom right')
        .hideDelay(3000);

      $mdToast.show(toast).then(function () {});
    };

    vm.cancelDeal = function (cancelArgs) {
      vm.model.lead_unit_assn = {};
      $rootScope.$broadcast('cancel.unit.reserved');
      changeViewState();
    };

    vm.extendDateSubmit = function () {
      var due_date =
        moment(vm.model.lead_unit_assn.due_date)
          .add(vm.extendDate, 'day')
          .format('YYYY-MM-DD') + ' 14:00';

      UnitDealLead.extendDeal(
        { id: vm.model.lead_unit_assn.id },
        { due_date: due_date },
        function (response) {
          vm.showExtendForm = false;
          vm.model.lead_unit_assn.due_date = response.due_date;
          $rootScope.$broadcast('activity.update');
        },
      );
    };

    vm.redirectToLead = function (leadId) {
      redirectToLead({
        leadId,
        $location,
        $state,
      });

      return false;
    };

    vm.addContact = function () {
      vm.showAddContact = !vm.showAddContact;
      vm.contact = {};
    };

    vm.addNewContact = function (contact, lead) {
      UnitDealLead.createAdditionalContact(
        { id: lead.id },
        { additional_contacts: contact },
        function (response) {
          if (!lead.additional_contacts) lead.additional_contacts = [];
          lead.additional_contacts.push(response);
          vm.showAddContact = false;
        },
      );
    };

    vm.cancelAddContact = function () {
      vm.showAddContact = false;
    };

    vm.editContactClick = function (contact, lead) {
      angular.forEach(vm.additional_contacts, function (additionalContact) {
        additionalContact.isEdit = false;
      });
      contact.isEdit = true;
      vm.editAdditionalContact = angular.copy(contact);
    };

    vm.saveContact = function (index, contact, lead) {
      delete contact.isEdit;
      UnitDealLead.updateAdditionalContact(
        { id: lead.id },
        { additional_contacts: contact, additional_id: index },
        function (response) {
          lead.additional_contacts[index] = contact;
        },
      );
    };

    vm.cancelEditContact = function (contact) {
      contact.isEdit = false;
    };

    vm.hasLink = function (str) {
      //estContactsChecker.hasLink(str);
      if (
        /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/.test(
          str,
        )
      )
        return true;
      else return false;
    };

    vm.hasEmail = function (str) {
      //estContactsChecker.hasEmail(str);
      if (
        /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i.test(
          str,
        )
      )
        return true;
      else return false;
    };

    vm.updateDealTotal = function (extraAmount) {
      vm.model.lead_unit_assn.deal.deal_total =
        Math.round(
          (vm.model.area_total *
            parseFloat(vm.model.lead_unit_assn.deal.price) +
            extraAmount) *
            100,
        ) / 100;
    };

    vm.lastLeadTooltip = '';
    var lsLead = null;

    initLSLead();

    $scope.$on('new.ls.lead', function (e, arg) {
      initLSLead();
    });

    function initLSLead() {
      if (localStorageService.get('lead')) {
        lsLead = localStorageService.get('lead');
      }

      if (lsLead) {
        var lastLeadTooltip = '';

        if (typeof lsLead.name !== 'undefined') {
          lastLeadTooltip = lsLead.name;
        } else {
          lastLeadTooltip = textNoName;
        }
        localStorage.setItem('leadId', lsLead.id);
        if (typeof lsLead.phone !== 'undefined' && lsLead.phone !== null) {
          lastLeadTooltip += ' +' + telFilter(lsLead.phone);
        }
        if (typeof lsLead.email !== 'undefined' && lsLead.email !== null) {
          lastLeadTooltip += ' ' + lsLead.email;
        }
        vm.lastLeadTooltip = lastLeadTooltip.trim();
      }
    }

    vm.fillWithLastLeadData = function () {
      vm.saveNewLead(lsLead);
      vm.leadExists = true;
    };

    vm.updateUnitResale = function (unitId, targetState) {
      if (targetState) {
        UnitDealLead.updateUnitResale(
          { id: unitId },
          { is_in_resale: 1 },
          function (response) {
            vm.model.is_in_resale = 1;
            //$rootScope.$broadcast('activity.update');
            $rootScope.$broadcast('resale.update', {
              unitId: unitId,
              resaleState: targetState,
            });
          },
          function (error) {},
        );
      } else {
        $mdDialog
          .show(
            $mdDialog
              .confirm()
              .title(
                $translate.instant(
                  'unit.popup.unitdeallead.cancel.resale.confirm.title',
                ),
              )
              .textContent(
                $translate.instant(
                  'unit.popup.unitdeallead.cancel.resale.confirm.text',
                ),
              )
              .ariaLabel('Alert Dialog')
              .ok(textGotIt)
              .cancel($translate.instant('general.cancel.long')),
          )
          .then(
            function () {
              UnitDealLead.updateUnitResale(
                { id: unitId },
                { is_in_resale: 0 },
                function (response) {
                  vm.model.is_in_resale = 0;
                  $rootScope.$broadcast('activity.update');
                  $rootScope.$broadcast('resale.update', {
                    unitId: unitId,
                    resaleState: targetState,
                  });
                },
                function (error) {},
              );
            },
            function () {},
          );
      }
    };

    vm.onChangeUnitAndSetResale = function (object) {
      var change = {
        area_total: object.area_total,
        is_price_per_meter: parseInt(object.is_price_per_meter),
        price:
          parseInt(object.is_price_per_meter) === 1
            ? object.current_price_set
            : object.current_cost_set,
        currency:
          object.current_currency_set != object.company_default_currency
            ? object.current_currency_set
            : null,
        exchange_rate_declared: object.exchange_rate_declared,
      };
      UnitDealLead.updateUnitParams(
        { id: object.unit_id },
        change,
        function (response) {
          $rootScope.$broadcast('unit.reload');
          $rootScope.$broadcast(
            'unit.update',
            Object.assign({}, change, { unitId: object.unit_id }),
          );
        },
        function (error) {},
      );
      vm.updateUnitResale(object.unit_id, true);
    };

    vm.onUnitResell = function (object) {
      UnitDealLead.updateLeadAssn(
        { id: object.leadUnitAssnId },
        { new_lead_id: object.selectedLead.originalObject.id },
        function (response) {
          $rootScope.$broadcast('unit.reload');
          $rootScope.$broadcast('resale.update', {
            unitId: object.unitId,
            resaleState: false,
          });
          $timeout(function () {
            vm.editDeal();
          }, 1000);
        },
        function (error) {},
      );
    };
  }
})();
